import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Observable, of, Subject } from 'rxjs';
import { DialogConfirmComponent } from 'src/app/core/components/dialog-confirm/dialog-confirm.component';
import { getProductsByOrderAgain, Product } from 'src/app/shop';
import { AddCartLine } from 'src/app/shop/models/cart.model';
import { Order, OrderLineItem } from 'src/app/shop/models/order.model';

@Component({
    selector: 'app-order-again-dialog',
    templateUrl: './order-again-dialog.component.html',
    styleUrls: ['./order-again-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OrderAgainDialogComponent implements OnInit, OnDestroy {
  products$: Observable<Product[]> = of([]);

  private _unsubscribe = new Subject<void>();

  newOrder: AddCartLine[] = [];

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      prefix: string;
      order: Order;
      products?: { [id: number]: Product };
      title?: string;
      text?: string;
      [key: string]: any;
    },
    private store: Store,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.products$ = this.store.select(getProductsByOrderAgain);

    this.newOrder = this.data.order.lineItems.map(l => ({
      merchandiseId: l.variant.id,
      quantity: l.currentQuantity,
    }));
  }

  ngOnDestroy(): void {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }

  closeDialog(e: boolean) {
    const orderLines = this.newOrder.filter(a => a.quantity !== 0);
    this.dialogRef.close(e ? orderLines : null);
  }

  handleLineUpdate(e: AddCartLine) {
    const index = this.newOrder.findIndex(a => a.merchandiseId === e.merchandiseId);
    this.newOrder[index] = e;
    this.cd.detectChanges();
  }

  get totalCount() {
    if (!this.newOrder || !this.newOrder.length) {
      return 0;
    }

    return this.newOrder.reduce((a, b) => a + (b['quantity'] || 0), 0);
  }

  getVariant(line: OrderLineItem) {
    return this.data.products?.[line.variant.product?.id].variants.filter(a => a.id === line.variant.id)?.[0];
  }
}
